import script from "./ApplyForCompany.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplyForCompany.vue?vue&type=script&setup=true&lang=ts"

import "./ApplyForCompany.vue?vue&type=style&index=0&id=f7984452&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7984452"]])

export default __exports__